import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShapes = () => {
  return (
    <g>
      <path d="m10.055 9 4.897.006c.58.001 1.048.47 1.048 1.05v4.894c0 .58-.47 1.05-1.049 1.05h-4.896a1.05 1.05 0 0 1-1.049-1.05v-4.9c0-.58.47-1.05 1.05-1.05zm-6.692-.123a.749.749 0 0 1 1.296 0l3.225 5.545A1.05 1.05 0 0 1 6.977 16H1.049a1.05 1.05 0 0 1-.907-1.578zm7.142 1.624V14.5H14.5v-3.995l-3.996-.004zm-6.494.244L1.83 14.5h4.364L4.01 10.745zM8.007 0a3.748 3.748 0 0 1 3.747 3.75A3.748 3.748 0 0 1 8.007 7.5a3.748 3.748 0 0 1-3.746-3.75A3.748 3.748 0 0 1 8.007 0zm0 1.5A2.249 2.249 0 0 0 5.76 3.75 2.249 2.249 0 1 0 8.007 1.5z" />
    </g>
  );
};

export default withIcon(IconShapes);
